<template>
  <div class="zcollege dinline-block prelative br5 trans3 cpointer tcenter" @click="goRoute(item.id)">
    <div class="igs br5 ofhidden pabsolute">
      <img class="img trans3" :src="item.image" width="294" height="220">
    </div>
    <div class="cur pabsolute br50 bgw pt15">
      <img class="br50" :src="item.logo" width="88" height="88">
    </div>
    <div class="zbtns pabsolute bgw pt20 dnone">
      <a href="javascript:;" class="zbtn zbtn-bgreen br8 trans3">院校详情</a>

    </div>
    <div class="txt pl20 pr20">
      <div class="fs20 fbold mb10">{{item.name}}</div>
      <div class="tc9 lh18" style="height: 80px;overflow: hidden;">{{item.description}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "school-item",
  props: [
    'item',
    'index',
  ],
  methods:{
    goRoute(id){
      let path = `/hedu/school/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      //this.$router.push({path:'/hedu/school/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .zindex-wrap .zcollege{/* margin: 0 12px; */}
  .zcollege{border-top-left-radius: 5px;border-top-right-radius: 5px;width: 294px;height: 395px;border: 1px solid #eee;}
  .zcollege:nth-child(4n+1){margin-left: 0;}
  .zcollege:nth-child(4n){margin-right: 0;}
  .zcollege:hover{box-shadow: 0 0 15px #ccc;}
  .zcollege:hover .zbtns{display: block;}
  .zcollege:hover .img{transform: scale(1.1);}
  .zindex-wrap .cedivs{left: -1px;top: -1px;width: 294px;height: 220px;}
  .zcollege .txt{margin-top: 265px;height: 100px;}
  .zcollege .cur{margin: auto;left: 0;right: 0;top: 150px;width: 118px;height: 118px;}
  .zcollege .zbtns{width: 100%;bottom: 0;height: 70px;}
  .zcollege .zbtn{padding: 6px 20px;}
</style>



// WEBPACK FOOTER //
// src/components/hedu/school-item.vue